<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">`{{ userName }}`用户临停车库</span>
    </p>
    <div style="position: relative;">
      <TableWrapper
        v-if="showModal"
        name="tbl_user_temporary_parking"
        :columns="columns"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :mod-count="modCount"
        :url="action"
        :show-add="false"
        :border="false"
      />
    </div>
    <div slot="footer">
      <Button
        type="primary"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="closeModal(false)"
      >
        关闭
      </Button>
    </div>
    <MemberTemporaryParking
      :id="entityId"
      :visible="modalForm"
      @on-close="onModalClose"
    />
  </Modal>
</template>

<script>
import request from '@/utils/request'
import { isAdmin, hasPermission } from '@/utils/app'
import { isBefore, getLinkTextStyle } from '@/utils/util'
import TableWrapper from '@/components/table-wrapper'
import MemberTemporaryParking from './user-parking-dialog'
export default {
  name: 'MemberTemporaryParkingListDialog',
  components: { TableWrapper, MemberTemporaryParking },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 75
    },
    userName: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      modalForm: false,
      modalOrderForm: false,
      submit: false,
      modCount: 0,
      entityId: 0,
      parkingId: 0,
      userId: 0
    }
  },
  computed: {
    deletePermitted() { return isAdmin() || hasPermission('PEM_TEMP_MEMBER_PARKING_DELETE') },
    updatePermitted() { return isAdmin() || hasPermission('PEM_TEMP_MEMBER_PARKING_UPDATE') },
    viewPayPermitted() { return isAdmin() || hasPermission('PEM_TEMP_MEMBER_VIEW_PAY') },
    offsetHeight() {
      return 480
    },
    action() {
      return this.$config.apiContextPath + '/temporary/parking?memberId=' + this.id
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    },
    columns() {
      const _this = this
      return [
        { title: '序号', type: 'index', width: 70, align: 'center' },
        { title: '临停车库', align: 'center', key: 'parking', sortable: true, ellipsis: true, tooltip: true, hidden: false },
        { title: '过期时间', align: 'center', key: 'expireTime', sortable: true, ellipsis: true, width: 160, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.expireTime || '---')
          }
        },
        { title: '剩余开门次数', align: 'center', key: 'remainOpeningTimes', sortable: true, ellipsis: true, tooltip: true },
        { title: '离场时间', align: 'center', key: 'terminateTime', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.terminateTime || '---')
          }
        },
        { title: '告警次数', align: 'center', key: 'reminderTimes', sortable: true, ellipsis: true, tooltip: true },
        { title: '状态', align: 'center', key: '_expire', sortable: true, width: 100,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.expireTime && isBefore(params.row.expireTime) ? 'green' : (params.row.expireTime ? 'red' : '#966') }
            }, params.row.expireTime ? (isBefore(params.row.expireTime) ? '未过期' : '已过期') : '---')
          }
        },
        { title: '操作', align: 'center', width: 220, disabled: true,
          render: (h, params) => {
            return h('div', [
              // h('a', {
              //   style: getLinkTextStyle(_this.viewPayPermitted),
              //   on: {
              //     click: () => {
              //       if (params.row.id && _this.viewPayPermitted) {
              //         this.showTemporaryParkingOrder(params.row.userId, params.row.parkingId, params.row.parkingName)
              //       }
              //     }
              //   }
              // }, [
              //   h('i', { class: { 'fas': true, 'fa-donate': true, 'cell-icon-link': true }}),
              //   h('span', { domProps: { title: _this.deletePermitted ? '缴费记录' : '您没有权限查看缴费记录' }}, '缴费记录')
              // ]),
              h('a', {
                style: getLinkTextStyle(_this.updatePermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.updatePermitted) {
                      this.showTemporaryParking(params.row.id, params.row.parkingId, params.row.parkingName)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', { domProps: { title: _this.deletePermitted ? '编辑临停' : '您没有权限编辑临停' }}, '编辑')
              ]),
              h('a', {
                style: getLinkTextStyle(_this.deletePermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.deletePermitted) {
                      this.showDelModalDialog(params.row.id, params.row.parking)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', { domProps: { title: _this.deletePermitted ? '删除临停' : '您没有权限删除临停' }}, '删除')
              ])
            ])
          }
        }
      ]
    }
  },
  methods: {
    onModalClose(changed) {
      this.modalForm = false
      this.entityId = 0
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    showTemporaryParking(id, parkingId, parkingName) {
      this.entityId = id
      this.modalForm = true
    },
    showTemporaryParkingOrder(userId, parkingId, parkingName) {
      this.modalOrderForm = true
      this.parkingId = parkingId
      this.userId = userId
    },
    showDelModalDialog(id, parking) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除临停信息么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, parking)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.$config.apiContextPath + '/temporary/parking/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '临停 `' + parking + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '临停 `' + parking + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.url = ''
      this.entityId = 0
      this.$emit('on-close', changed)
    }
  }
}
</script>
